/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_ContactInputs */

const he_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יצירת קשר`)
};

const en_footer_contact = /** @type {(inputs: Footer_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Footer_ContactInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const footer_contact = /** @type {((inputs?: Footer_ContactInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_ContactInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_footer_contact(inputs)
	return en_footer_contact(inputs)
});